﻿/**
 * SASS Burger Menu
 *
 */

(function ($) {
    $.fn.rlBurger = function () {
        //burger menu
        $('#burger-menu').on('click', function () {
           $(this).toggleClass('is-active');
        });
    }
}(jQuery));